import React, { useState } from "react";
import CheckedRadio from "./CheckedRadio";
import { Checkbox, Input, Selector } from "../Elements";
import GroupTitle from "./GroupTitle";
import { NumberFormatValues } from "react-number-format";
import { getCustomerBalance, isAmountValid, isInputValidationError } from "../../../common/helpers/paymentHelpers";
import { toast } from "react-toastify";
import { RootStateType } from "../../../store/RootState";
import { useSelector } from "react-redux";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { PaymentPageTypes } from "../../../common/types/PaymentTypes";
import { OptionModel } from "../../../common/types/OptionModel";


type AmountSelectTypes = "freeInput" | "customerBalance";
type AmountTypeSelectRadio = {
    type: AmountSelectTypes,
    text: string
}

const customerSelectTypeRadioList: Array<AmountTypeSelectRadio> = [
    {
        type: "freeInput",
        text: "Serbest Tutar"
    },
    {
        type: "customerBalance",
        text: "Borç Bakiyesi"
    }
];


type Props = {
    amount: string,
    setAmount: (amount: string) => void,
    paymentAmountTypeVisible: boolean,
    customerId: number,
    amountVisible: boolean,
    descriptionVisible: boolean,
    selectedCurrency: number,
    setSelectedCurrency: (currencyId: number) => void,
}
export type PaymentMasterRef = {
}
const PaymentMasterArea = React.forwardRef<PaymentMasterRef, Props>((props: Props, ref) => {

    const { firmInformations } = useRecoilValue(tenantState);

    const { validationErrors } = useSelector((state: RootStateType) => state.paymentPage);

    const { amount, paymentAmountTypeVisible, setAmount, customerId, amountVisible, selectedCurrency } = props;

    const [amountSelectType, setAmountType] = useState<AmountSelectTypes>("freeInput");
    const [customerBalanceLoading, setCustomerBalanceLoading] = useState(false);
    const currencySelectList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyListForSelect);


    const selectCustomerBalance = async () => {
        setCustomerBalanceLoading(true);

        const balance = await getCustomerBalance(customerId);
        if (balance.isSuccess) {
            setAmount(balance.data || "0"); 
        }

        setCustomerBalanceLoading(false);

    }

    const onClickAmountType = (type: AmountSelectTypes) => {
        if (type == "customerBalance") {
            if (customerId > 0) {
                setAmountType(type);
                selectCustomerBalance();
            } else {
                toast.error("Lütfen önce müşteri seçiniz.");
            }

        } else {
            setAmountType(type);
        }
    }

    const onCurrencyChange = (item: OptionModel) => {
        const selected = item.value;

        props.setSelectedCurrency(selected);
    }

    const getSelectedCurrency = () => {

        const index = currencySelectList.findIndex(w => w.value == selectedCurrency);
        return currencySelectList[index];
    }


    const getCurrencyView = () => {
        if (currencySelectList.length > 0) {

            return (
                <div className="mt-4 w-full ">
                    <Selector
                        backgroundColor="white"
                        options={currencySelectList}
                        name="sendType"
                        placeholder={"Para Birimi"}
                        className="w-full"
                        onChange={onCurrencyChange}
                        defaultValue={getSelectedCurrency()}
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    const AmountSelectType = () => (
        <div className=" w-full mt-4 ">
            <div className=" w-full justify-between items-center inline-flex">
                {customerSelectTypeRadioList.map((item, index) => {
                    const isSelected = amountSelectType == item.type;
                    const selectedTextClass = isSelected ? "text-slate-900" : "text-slate-500";
                    const selectedBorder = isSelected ? "border-blue-700" : "border-gray-200";

                    return (
                        <button key={index + "customerSelectTypeRadioList"}
                            onClick={() => onClickAmountType(item.type)}
                            className={`w-full h-[60px] p-3 bg-white cursor-pointer rounded-lg border-2 ${index == 0 && "mr-2"} ${selectedBorder} justify-between items-center flex`}>
                            <div className={`${selectedTextClass} text-[13px] font-normal font-['Helvetica'] leading-none tracking-tight`}>
                                {item.text}
                            </div>
                            {isSelected && <CheckedRadio />}
                        </button>
                    );
                })}
            </div>
        </div>
    );

    if (!amountVisible) {
        return null;
    }

    return (
        <div className="w-full  bg-white flex-col justify-start items-start flex">
            <GroupTitle title="Ödeme Bilgileri" />
          
            {paymentAmountTypeVisible && firmInformations.isCustomerBalance && (
                <AmountSelectType />
            )}
              {firmInformations.isCurrency === true ?  getCurrencyView() : ""}
            <div className="w-full">
                {amountVisible && (
                    <div className="mt-4">
                    <Input
                        label=""
                        className="w-full bg-white "
                        name="amount"
                        disabled={amountSelectType == "customerBalance"}
                        required
                        placeholder="Tutar Giriniz"
                        currencyformat={true}
                        onValueChange={(values: NumberFormatValues) => setAmount(values.formattedValue)}
                        type="text"
                        value={amount}
                        loading={customerBalanceLoading}
                        error={isInputValidationError("inputAmount", validationErrors) && !isAmountValid(amount)}
                    />
                    </div>
                )}
            </div>


        </div>
    );
})
export default PaymentMasterArea;